<template>
	<header class="">
		<div class="h-top box align-center">
			<div class="logo"><h1><router-link :to='{name:"homeView"}'>和数传媒</router-link></h1></div>
			<div class="search flex-1 box align-center" @click="showSearch">
				<i class="iconfont icon-search"></i>
				<div>搜索</div>
			</div>
	        <div class="userbar">
	        	<router-link :to="{name:'memberIndex'}" v-if="isLog">
	        		<i class="iconfont">&#xe65f;</i>
	        	</router-link>
	        	<router-link :to="{name:'loginView',params:{from:'member'}}" v-else>
	        		<i class="iconfont">&#xe602;</i>
	        	</router-link>		
	        </div>
		</div>
        <nav class="nav flex-1" ref="nav">
            <ul class="nav-list swiper-wrapper">
            	<router-link :to='{name:"homeView"}' tag='li' class="nav-item swiper-slide">首页</router-link>
        		<router-link :to='{name:"newsView"}' tag='li' class="nav-item swiper-slide">新闻</router-link>
        		<router-link :to='{name:"bigView"}' tag='li' class="nav-item swiper-slide">大咖说</router-link>
        		<router-link :to='{name:"videoView"}' tag='li' class="nav-item swiper-slide">视频</router-link>
        		<router-link :to='{name:"featuredView"}' tag='li' class="nav-item swiper-slide">深度</router-link>
        		<router-link :to='{name:"policyView"}' tag='li' class="nav-item swiper-slide">政策</router-link>
            </ul>
            <div class="shadow-bg"></div>
        </nav>
	</header>
</template>
<script>
	import {getCookie} from '../common/util/config.js'
	import Swiper from 'swiper'
	import $ from 'jquery'
	export default {
		data () {
			return {
				isLog : false
			}
		},
		mounted () {
			this.$nextTick (function(){
				var s_nav = new Swiper(this.$refs.nav, {
	              slidesPerView: 'auto',
	              freeMode: true,
	              wrapperClass : 'nav-list',
	              slideClass : 'nav-item',
	              observer:true,
            	  observeParents:true,
                onClick: function(){
                  var slides = s_nav.slides
                  var that = s_nav;
                  var navLeft = $(".nav").offset().left;
                  slides.each(function(index,el){
                    if($(el).hasClass("active"))
                    {   
                         var navActiveSlideLeft = el.offsetLeft;
                         var clientWidth = parseInt(s_nav.wrapper.eq(0).css('width'));
                         var navSlideWidth = parseInt($(el).innerWidth());
                         var navWidth = 0
                         // console.log(navActiveSlideLeft,clientWidth,navSlideWidth)
                         for (let i = 0; i < that.slides.length; i++) {
                            navWidth += parseInt($(".nav .nav-item").innerWidth())
                        }
                        // console.log(navActiveSlideLeft,clientWidth,navSlideWidth,navWidth)
                         if (navActiveSlideLeft < (clientWidth - parseInt(navSlideWidth)) / 2) {
                            that.setWrapperTranslate(0)
                        } else if (navActiveSlideLeft > navWidth - (parseInt(navSlideWidth) + clientWidth) / 2) {
                            that.setWrapperTranslate(clientWidth - navWidth)
                        } else {
                            that.setWrapperTranslate((clientWidth - parseInt(navSlideWidth)) / 2 - navActiveSlideLeft)
                        }
                    }
                  })
                } 
	            });
	            // console.log(s_nav);
			})
			let cookie = document.cookie;
			let mobile = getCookie(cookie,'mobile');
			let token = getCookie(cookie,'token');
		    if(mobile == undefined || token == undefined){
		    	this.isLog = false
		    }else{
		    	this.isLog = true
		    }
		},
		methods: {
			showSearch () {
				this.$emit('showSearch')
			}
		}
	}
</script>
<style lang="scss">
	@import 'common/scss/_variabel.scss';
	header{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		background: #fff;
		box-shadow: 0 0 4px 2px rgba(26,93,173,.03);
		z-index: 888;
		.h-top{
			height: 1rem;
			.search{
				height: .66rem;
				background: #f4f4f4;
				border-radius:.32rem;
				padding: 0 .2rem;
				box-sizing:border-box;
				font-size:.28rem;
				.iconfont{
					font-size:.38rem;
					color:#666;
					margin-right: .2rem;
				}
			}
		}
		.logo{
			margin:0 .2rem;
			h1 a{
				display: block;
			    height: .58rem;
			    width: .58rem;
			    overflow: hidden;
			    text-indent: -999px;
			    background: url(../common/images/logo.png) center no-repeat;
			    background-size: contain;
			}
		}
		.userbar{
		    height: .55rem;
		    line-height:.55rem;
		    margin: 0 .2rem;
		    .iconfont{
		    	font-size: .45rem;
		    	font-weight: bold;
		    }
		}
		.nav{
			height: .6rem;
		    line-height: .6rem;
		    overflow: hidden;
		    padding: .1rem 0 .15rem;
		    margin:0 .3rem;
		    position: relative;
		    .nav-item{
				white-space: nowrap;
				font-size: .32rem;
			    color: $titleColor;
			    position: relative;
			    padding-right: .55rem;
			    height: .6rem;
				line-height:.6rem;
				width: auto;
			    &.active{
			    	color: #1a5dad;
			    	&:before{
			    		content: '';
					    position: absolute;
					    height: 2px;
					    background: #1a5dad;
					    bottom: 0;
					    left: 0;
					    right: 0;
					    margin-right: .55rem;
			    	}
			    }
		    }
		    .shadow-bg{
		    	position: absolute;
			    top: .2rem;
			    right: -.1rem;
			    width: .2rem;
			    height: .55rem;
			    background: url(../common/images/shadow.png) center center no-repeat;
		    }
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Head.vue